/**
 * Converts an object into a query string.
 *
 * @param params - An object containing key-value pairs to be converted into a query string.
 * @returns A query string starting with '?' if the object is not empty, otherwise an empty string.
 */
export function createQueryStringFromObject(params: Record<string, any>): string {
  const searchParams = new URLSearchParams();

  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      const value = params[key];
      if (value !== undefined && value !== null) {
        searchParams.append(key, value.toString());
      }
    }
  }

  const queryString = searchParams.toString();
  return queryString ? `?${queryString}` : "";
}
